// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorRequests = (client) => ({
    /**
     * `POST /vendor/requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateRequest
     * @source packages/modules/requests/src/api/vendor/requests/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/requests", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListRequests
     * @source packages/modules/requests/src/api/vendor/requests/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/requests", { method: "GET", query, headers }),
    /**
     * `GET /vendor/requests/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetRequestById
     * @source packages/modules/requests/src/api/vendor/requests/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/requests/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/requests/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateRequestData
     * @source packages/modules/requests/src/api/vendor/requests/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/requests/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=requests.js.map